export default __webpack_public_path__ + "static/interior-6c6ab82d95433ae57eb01028910544bf.png";